import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import type { UseAROver90Result } from '@hooks/dashboard/useAROver90'
import {
  formatCurrency,
  HYGIENE_PLACEHOLDER,
} from '@utils/dashboardFinance.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { FinanceMetricTileItem } from '../../FinanceMetricTiles.component'
import { dashboardFinanceMetricFooter } from '../shared/dashboardFinanceMetricFooter'

type AROver90DayCardProps = {
  titleHref: string
  arOver90: UseAROver90Result
  className?: string
}

export function AROver90DayCard({
  titleHref,
  arOver90,
  className,
}: AROver90DayCardProps): React.ReactElement {
  const {
    loading,
    summary,
    hasData,
    hasPayload,
    arOver90BalanceGoalLabel: goalLabel,
  } = arOver90
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="AR over 90-day"
      titleHref={titleHref}
      className={['dashboard-finance-metric-card', className]
        .filter(Boolean)
        .join(' ')}
      loading={pending}
      skeleton={{ metrics: 1, block: 'none' }}
      isEmpty={isEmpty}
    >
      <FinanceMetricTileItem
        leftLabel="AR over 90-day"
        value={
          loading || !summary
            ? HYGIENE_PLACEHOLDER
            : formatCurrency(summary.arOver90.current, { compact: true })
        }
        rightLabel={goalLabel}
        footer={
          summary ? dashboardFinanceMetricFooter(summary.arOver90) : undefined
        }
      />
    </DashboardSectionCard>
  )
}
